import { render } from "./EnbCategory.vue?vue&type=template&id=0b970dbe&scoped=true"
import script from "./EnbCategory.vue?vue&type=script&lang=js"
export * from "./EnbCategory.vue?vue&type=script&lang=js"

import "./EnbCategory.vue?vue&type=style&index=0&id=0b970dbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b970dbe"]])

export default __exports__